import { useUserTermsModal } from "../composables/modal";

export default defineNuxtPlugin((nuxtApp) => {
  let userTermsModal: ReturnType<typeof useUserTermsModal> | undefined;

  addRouteMiddleware((to, from) => {
    if (process.server) {
      return;
    }

    if (to.path.indexOf("/dealer") === -1) {
      return;
    }

    const authStore = useAuthUser();

    if (!authStore.user) {
      return;
    }

    if (authStore.user.roleId === 1 || authStore.user.roleId === 3) {
      return;
    }

    if (authStore.user.acceptTerms) {
      return;
    }

    setTimeout(() => {
      nuxtApp.runWithContext(() => {
        if (!userTermsModal) {
          userTermsModal = useUserTermsModal();
        }
        userTermsModal.open();
      });
    }, 1500);
  });
});
